import { addNodeId } from './nodeIdPool';

export const systemIntents = [
  { id: '_miss', name: '未匹配', type: 'play' },
  { id: '_knowledge', name: '知识问答' },
  { id: '_success', name: '有效', type: 'collect' },
  { id: '_failed', name: '无效', type: 'collect' },
]

export function createNode(node) {
  if (node.type === 'play') {
    return createPlayNode(node)
  } else if (node.type === 'collect' ) {
    return createCollectNode(node);
  } else if (node.type === 'jump') {
    return createJumpNode(node)
  } else if (node.type === 'condition') {
    return createConditionNode(node)
  } else if (node.type === 'llm') {
    return createLLMNode(node)
  } else if (node.type === 'thirdllm') {
    return createThirdLLMNode(node)
  }
  return {}
}

export function createPlayNode(node) {
  const outs = (node.outs || []);
  const systemOut = systemIntents
    .filter(intent => intent.type === 'play')
    .map(intent => ({
      intent_id: intent.id, target_id: '',
    }));
  return {
    id: addNodeId('P'),
    name: node.name,                //节点名称 在该流程内唯一 不得重复
    type: node.type,                 //节点类型  play(放音节点) /collect (采集节点)/ jump (跳转节点)
    voices: node.voices,           //话术录音
    is_multi_prologue_node: node.is_multi_prologue_node,
    can_break: node.can_break,             //是否允许打断
    break_delay: node.break_delay,             // 延时打断时长 前__ms不打断
    playback_delay: node.playback_delay, // 延迟播放时长
    tag: node.tag,                  //命中时添加标签 
    top: '200',
    left: '0',
    outs: [...outs, ...systemOut ].map(out => ({
      id: addNodeId('O'),
      intent_id: out.intent_id,
      target_id: '',
    })),                       //节点出口定义
    hmc_remind: node.hmc_remind,
    hmc_skill_id: node.hmc_skill_id,
    hmc_after_play: node.hmc_after_play,
    vars: node.vars,                      //命中时变量操作
    enable_dtmf: node.enable_dtmf, // 是否启用按键
    dtmf_digits_length: node.dtmf_digits_length, // 收号长度 0-不限制
    dtmf_terminator: node.dtmf_terminator, // 收号终止字符
  }
}

export function createCollectNode(node) {
  const systemOut = systemIntents
    .filter(intent => intent.type === 'collect')
    .map(intent => ({
      intent_id: intent.id, target_id: '',
    }));
  return {
    id: addNodeId('C'),
    name: node.name,                //节点名称 在该流程内唯一 不得重复
    type: node.type,                 //节点类型  play(放音节点) /collect (采集节点)/ jump (跳转节点)
    voices: node.voices,           //话术录音
    can_break: node.can_break,             //是否允许打断
    break_delay: node.break_delay,             // 延时打断时长 前__ms不打断
    playback_delay: node.playback_delay, // 延迟播放时长
    tag: node.tag,                  //命中时添加标签 
    collect_field_name: node.collect_field_name,  //采集字段名称 提取成功后将以 k:v形式进行输出
    collect_rule: node.collect_rule,  //采集规则 正则表达式 用于信息提取  空时匹配全部
    vars: node.vars,                      //命中时变量操作
    outs: systemOut.map(out => ({
      id: addNodeId('O'),
      intent_id: out.intent_id,
      target_id: '',
    })), 
    hmc_remind: node.hmc_remind,
    hmc_skill_id: node.hmc_skill_id,
    hmc_after_play: node.hmc_after_play,
    input_timeout: node.input_timeout,
    no_timeout_voice: node.no_timeout_voice,
    collect_confirm_voices: node.collect_confirm_voices,
    collect_confirm_keywords: node.collect_confirm_keywords,
    collect_refuse_keywords: node.collect_refuse_keywords,
    enable_dtmf: node.enable_dtmf, // 是否启用按键
    dtmf_digits_length: node.dtmf_digits_length, // 收号长度 0-不限制
    dtmf_terminator: node.dtmf_terminator, // 收号终止字符
    top: '200',
    left: '0',
  }
}

export function createJumpNode(node) {
  return {
    id: addNodeId('J'),
    name: node.name,                //节点名称 在该流程内唯一 不得重复
    type: node.type,                 //节点类型  play(放音节点) /collect (采集节点)/ jump (跳转节点)
    voices: node.voices,           //话术录音
    can_break: node.can_break,             //是否允许打断
    break_delay: node.break_delay,             // 延时打断时长 前__ms不打断
    playback_delay: node.playback_delay, // 延迟播放时长
    tag: node.tag,                  //命中时添加标签 
    action: node.action,      //跳转动作  jump / hangup (挂机) / transfer （转接）
    action_data: node.action_data,   //动作参数
    vars: node.vars,                      //命中时变量操作
    hmc_remind: node.hmc_remind,
    hmc_skill_id: node.hmc_skill_id,
    hmc_after_play: node.hmc_after_play,
    enable_dtmf: node.enable_dtmf, // 是否启用按键
    dtmf_digits_length: node.dtmf_digits_length, // 收号长度 0-不限制
    dtmf_terminator: node.dtmf_terminator, // 收号终止字符
    top: '200',
    left: '0',
  }
}

export function createConditionNode(node) {
  return {
    id: addNodeId('D'),
    name: node.name,                //节点名称 在该流程内唯一 不得重复
    type: node.type,                 //节点类型  play(放音节点) /collect (采集节点)/ jump (跳转节点)
    outs: node.outs?.map(out => ({
      id: addNodeId('O'),
      name: out.name,
      tag: out.tag,
      vars: out.vars,
      conditions: out.conditions,
      target_id: '',
    })),      //出口
    top: '200',
    left: '0',
  }
}


export function createLLMNode(node) {
  return {
    id: addNodeId('L'),
    model: node.model,
    prompt: node.prompt,
    dialog: node.dialog,
    name: node.name,                //节点名称 在该流程内唯一 不得重复
    type: node.type,                 //节点类型  play(放音节点) /collect (采集节点)/ jump (跳转节点)
    can_break: node.can_break,             //是否允许打断
    break_delay: node.break_delay,             // 延时打断时长 前__ms不打断
    playback_delay: node.playback_delay, // 延迟播放时长
    tag: node.tag,                  //命中时添加标签 
    top: '200',
    left: '0',
    vars: node.vars,                      //命中时变量操作
  }
}

export function createThirdLLMNode(node) {
  return {
    id: addNodeId('L'),
    name: node.name,                // 节点名称
    type: node.type,                // 'thirdllm'
    agentid: node.agentid,
    trunk_ip: node.trunk_ip,
    tag: node.tag || '',
    top: node.top || '200',
    left: node.left || '0',
    // 暂时先隐藏，以备未来随时使用
    // model: node.model,
    // prompt: node.prompt,
    // dialog: node.dialog,
    // vars: node.vars,
  }
}
